import RusticLeaves from "./assets/rusticLeaves.png";
import "./divider.css";

const Divider = () => {
  return <img src={RusticLeaves} alt="divider" className="divider" />;
};

export default Divider;
